import React from 'react';
import { Instagram } from 'lucide-react';

const INSTAGRAM_POSTS = [
  {
    image: "https://customer-assets.emergentagent.com/job_8010d79a-e92b-49b5-9c1b-b21bc7b6963a/artifacts/p3ev29um_Screenshot_20180415-005858~2.png",
    alt: "Lion Heart"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_8010d79a-e92b-49b5-9c1b-b21bc7b6963a/artifacts/lbl08bcv_Screenshot_2019-08-19-17-10-42.png",
    alt: "Punk"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_akanni-imagery/artifacts/ecbjahvk_9df5efb4-fb30-49aa-a762-6e567aa35799-1_all_359.jpeg",
    alt: "Emerge"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_akanni-imagery/artifacts/a3gel2tr_IMG_1025.png",
    alt: "Phaeton Mark"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_akanni-imagery/artifacts/1gmglrzm_9df5efb4-fb30-49aa-a762-6e567aa35799-1_all_134.jpeg",
    alt: "Veil of Light"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_akanni-imagery/artifacts/54a2odhd_IMG_0966.jpeg",
    alt: "Ignition"
  }
];

export default function InstagramFeed() {
  return (
    <section className="py-16 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <Instagram size={20} className="text-[#C5A059]" strokeWidth={1.5} />
            <a
              href="https://www.instagram.com/phaetonimagery/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-sm text-[#F5F5F0] hover:text-[#C5A059] transition-colors"
              data-testid="instagram-handle"
            >
              @phaetonimagery
            </a>
          </div>
          <a
            href="https://www.instagram.com/phaetonimagery/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C5A059] hover:text-[#E0BE77] transition-colors"
            data-testid="instagram-follow"
          >
            Follow on Instagram
          </a>
        </div>

        {/* Grid — Instagram style */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-1">
          {INSTAGRAM_POSTS.map((post, i) => (
            <a
              key={i}
              href="https://www.instagram.com/phaetonimagery/"
              target="_blank"
              rel="noopener noreferrer"
              className="relative group aspect-square overflow-hidden"
              data-testid={`ig-post-${i}`}
            >
              <img
                src={post.image}
                alt={post.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                <Instagram
                  size={24}
                  className="text-white opacity-0 group-hover:opacity-100 transition-opacity"
                  strokeWidth={1.5}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
